import React from 'react'
import './style.css'
import NRTBullet from "./Bullet"

const NRTBulletList = (props) => (
    <div className={'nrt-bullet-list'}>
        {props.children}
    </div>
)

NRTBulletList.Bullet = NRTBullet

NRTBulletList.propTypes = {}

NRTBulletList.defaultProps = {}

export default NRTBulletList



// WEBPACK FOOTER //
// ./src/components/_common/BulletList/index.js